module.exports = __webpack_public_path__ + "static/media/great-taste-white.8ff8b7f5.png";